module.exports = __webpack_public_path__ + "img/sofa-material.9627dc1.jpg";